export default __webpack_public_path__ + "static/media/mad_martinize2.59ecd2d0.png";